// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import SalesUserTable from './sales-table';
// assets
//

// ----------------------------------------------------------------------

export default function SalesAdmin() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <SalesUserTable />
        </Container >
    );
}
